import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { AuthLayout, AuthField, AuthError, SubmitButton, useSubmitState } from "@/components/auth/AuthParts";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const { error, loading, submit } = useSubmitState(async () => {
    if (password !== confirm) throw new Error("Passwords don't match");
    const { data } = await api.post("/auth/reset-password", { token, password });
    navigate("/login", { replace: true, state: { notice: data.message } });
  });

  const footer = <>Link expired? <Link to="/forgot-password" data-testid="reset-request-new-link" className="link-blue">Request a new one →</Link></>;

  return (
    <AuthLayout title="Choose New Password" testId="reset-password-page" footer={footer}>
      <div className="mt-6 border-2 border-black p-6 space-y-4 bg-white hard-shadow">
        {!token ? (
          <AuthError testId="reset-missing-token" message="This reset link is missing or broken. Please request a new one." />
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <AuthField label="New Password" testId="reset-password" type="password" minLength={6} autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} />
            <AuthField label="Confirm New Password" testId="reset-password-confirm" type="password" minLength={6} autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            <p className="font-mono-data text-[10px] uppercase text-gray-500">At least 6 characters.</p>
            <AuthError testId="reset-error" message={error} />
            <SubmitButton testId="reset-submit" loading={loading}>Update Password</SubmitButton>
          </form>
        )}
      </div>
    </AuthLayout>
  );
}
